import React, { Component } from "react";
import {
  Button,
  Confirm,
  Container,
  Form,
} from "semantic-ui-react";
import Flatpickr from "react-flatpickr";
import set from "lodash/set";

import request from "../../utils/request";

import ResponseMessage from "../../components/common/ResponseMessage";

const sellerProfile = () => {
  return {
    id: 0,
    login: "",
    first_name: "",
    last_name: "",
    email: "",
    phone_number: "",
    birthday: "",
    nonprofit_id: 0,
    id_number: "",
    role: "seller",
    deleted_at: null
  };
};
const resetState = () => {
  return {
    isLoading: false,
    xhrStatus: "",
    xhrMessage: "",
    nonProfitList: [
      {
        key: 0,
        text: "Select Non Profit",
        value: 0
      }
    ],
    sellerId: 0,
    profile: sellerProfile()
  };
};
class Profile extends Component {
  constructor(props) {
    super(props);
    this.state = resetState();
    let id = this.props.match.params.id ? this.props.match.params.id : 0;
    this.state.sellerId = id;
  }
  componentDidMount = () => {
    if (this.props.match.params.id === ":id") {
      this.props.history.replace("/sellers");
      return;
    }
    this.setState({ isMounted: true });
    this.fetchData();
  };
  componentWillUnmount = () => {
    this.setState(resetState());
  };
  fetchData = () => {
    this.setState({ isLoading: true });
    let self = this;
    let promises = [request.get(this, "api:/non-profit", {})];
    if (this.state.sellerId > 0) {
      promises.push(
        request.get(this, `api:/volunteer/${this.state.sellerId}?ts=${Date.now()}`)
      );
    }
    Promise.all(promises).then(function(values) {
      self.setNonprofitList(values[0]);
      if (values[1]) {
        self.setProfile(values[1]);
      }
      self.setState({ isLoading: false });
    });
  };
  handleChange = (e, { name, value }) => {
    let data = this.state.profile;
    set(data, name, value);
    this.setState({ profile: data });
  };
  handleContent = e => {
    let name = e.target.dataset.key;
    let value = e.target.textContent;
    let data = this.state.profile;
    set(data, name, value);
    this.setState({ profile: data });
  };
  setNonprofitList = result => {
    if (!this.state.isMounted) return false;
    let nonProfitList = [];
    result.data.map(
      (value) => {
        return nonProfitList.push({
          key: value.id,
          text: value.name,
          value: value.id
        })
      }
    );
    this.setState({
      nonProfitList: nonProfitList,
      isLoading: this.state.sellerId === 0 ? false : true
    });
  };
  setProfile = resp => {
    this.setState({
      profile: resp,
      isLoading: false
    });
  };
  showConfirm = (id, title) => {
    this.setState({ confirmOpen: true, confirmId: id, confirmTitle: title });
  };
  handleConfirm = () => {
    if (this.state.profile.deleted_at == null) {
      this.deleteSeller();
    } else {
      this.restoreSeller();
    }
  };
  handleCancel = () => {
    this.setState({
      result: "cancelled",
      confirmOpen: false,
      confirmId: 0,
      confirmTitle: ""
    });
  };
  deleteSeller = () => {
    let payload = { id: this.state.confirmId, ts: Date.now() };
    this.setState({
      loading: true,
      confirmOpen: false,
      confirmId: 0,
      confirmTitle: ""
    });
    return request.delete(this, `api:/volunteer/${this.state.confirmId}`, payload).then(resp => {
      this.setState({
        xhrStatus: resp.success ? "success" : "error",
        xhrMessage: resp.message,
        loading: false
      });
      return this.fetchData();
    });
  };
  restoreSeller = () => {
    let payload = { volunteerId: this.state.confirmId };
    this.setState({
      loading: true,
      confirmOpen: false,
      confirmId: 0,
      confirmTitle: ""
    });
    return request.post(this, `api:/volunteer/restore`, payload).then(resp => {
      this.setState({
        xhrStatus: resp.success ? "success" : "error",
        xhrMessage: resp.message,
        loading: false
      });
      return this.fetchData();
    });
  };
  handleSubmit = () => {
    this.setState({
      isLoading: true
    });

    let req;
    const { profile } = this.state;
    if (profile.id > 0) {
      req = request.put(this, `api:/volunteer/${profile.id}`, profile);
    } else {
      req = request.post(this, "api:/volunteer", profile);
    }
    req.then(resp => {
    var message;
    if (resp.errors) {
      message = Object.keys(resp.errors).map(e => {
        return <div>{resp.errors[e][0]}</div>;
      });
    }
    if (resp.exception) {
      message = "A seller already exists with the provided login"
    }

    this.setState({
      isLoading: false,
      xhrStatus: resp.errors ? "error" : resp.success ? "success" : "error",
      xhrMessage: message ? message : resp.message
    });

    if (resp.success) {
      if (this.state.sellerId === 0) this.setState({ profile: sellerProfile() });
      setTimeout(() => this.setState({ xhrStatus: '', xhrMessage: '' }), 4000);
    }

    });
  };
  handleResetNP = () => {
    const { profile } = this.state;
    profile.nonprofit_id = 0;
    this.setState({ profile });
  }
  handleDismissPortal = () => {
    if (this.state.xhrStatus === '') return null;
    this.setState({ xhrStatus: '', xhrMessage: '' });
  }
  render() {
    const {
      isLoading,
      xhrStatus,
      xhrMessage,
      nonProfitList,
      profile,
      confirmOpen,
      confirmTitle
    } = this.state;
    return (
      <Container text>
        <Confirm
          open={confirmOpen}
          content={confirmTitle}
          cancelButton="Cancel"
          confirmButton="Confirm"
          onCancel={this.handleCancel}
          onConfirm={this.handleConfirm}
        />
        <Form
          id="campaignForm"
          loading={isLoading}
          success={xhrStatus === "success"}
          error={xhrStatus === "error"}
          onBlur={this.handleDismissPortal}
        >
          <Form.Input
            fluid
            name="login"
            label="login"
            placeholder="Login"
            value={profile.login}
            onChange={this.handleChange}
            required
          />
          <Form.Input
            fluid
            name="first_name"
            label="First Name"
            placeholder="First Name"
            value={profile.first_name}
            onChange={this.handleChange}
            required
          />
          <Form.Input
            fluid
            name="last_name"
            label="Last Name"
            placeholder="Last Name"
            value={profile.last_name}
            onChange={this.handleChange}
          />
          <Form.Input
            fluid
            name="email"
            label="Email"
            placeholder="Email"
            value={profile.email}
            onChange={this.handleChange}
          />
          <Form.Input
            fluid
            name="phone_number"
            label="Phone Number"
            placeholder="Phone"
            value={profile.phone_number}
            onChange={this.handleChange}
          />
          <Form.Input
            fluid
            name="id_number"
            label="Identification number"
            placeholder="Identification number"
            value={profile.id_number}
            onChange={this.handleChange}
          />
          <Form.Field>
            <label>Birthday</label>
            <Flatpickr
              name="birthday"
              placeholder="Birthday"
              value={profile.birthday}
              autoComplete="off"
              onChange={(_, str, b) =>
                this.handleChange(b.element, {
                  name: "birthday",
                  value: str
                })
              }
            />
          </Form.Field>
          <Form.Group inline className="createSellerNonProfitGroup">
            <Form.Select
              name="nonprofit_id"
              label="Non-profit"
              options={nonProfitList}
              value={profile.nonprofit_id}
              onChange={this.handleChange}
              className="createSellerNonProfitDropdown"
            />
            <Form.Button
              type="button"
              icon={"delete"}
              size="mini"
              color={"red"}
              onClick={this.handleResetNP}
              className="refreshNonProfitDropdown"
            />
          </Form.Group>
          <Button 
            primary 
            onClick={this.handleSubmit} 
            icon="save" 
            content="Save" 
            floated="right" 
          />
          {+profile.id > 0 && <Button
            floated="right"
            color={profile.deleted_at == null ? "red" : "green"}
            onClick={() =>
              this.showConfirm(
                profile.id,
                "Are you sure you want to " + (profile.deleted_at == null ? "delete " : "restore ") + profile.first_name + " " + profile.last_name + "(" + profile.login + ")?"
              )
            }
            content={profile.deleted_at == null ? "Delete" : "Restore"}
            icon={profile.deleted_at == null ? "trash" : "undo"}
          />}
          <ResponseMessage status={xhrStatus} message={xhrMessage} />
        </Form>
      </Container>
    );
  }
}

export default Profile;
